"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _unmutable = _interopRequireDefault(require("./internal/unmutable"));

var _pipeWith = _interopRequireDefault(require("./util/pipeWith"));

var _entryArray = _interopRequireDefault(require("./entryArray"));

var _set = _interopRequireDefault(require("./set"));

// TODO - should be setMutate
var _default = (0, _unmutable.default)({
  name: 'map',
  immutable: 'map',
  record: function record(mapper) {
    return function (value) {
      return (0, _pipeWith.default)(value, (0, _entryArray.default)(), function (entries) {
        return entries.reduce(function (record, _ref) {
          var _ref2 = (0, _slicedToArray2.default)(_ref, 2),
              key = _ref2[0],
              childValue = _ref2[1];

          return record.set(key, mapper(childValue, key, record));
        }, value);
      });
    };
  },
  array: function array(mapper) {
    return function (value) {
      return value.map(mapper);
    };
  },
  all: function all(mapper) {
    return function (value) {
      return (0, _pipeWith.default)(value, (0, _entryArray.default)(), function (entries) {
        return entries.reduce(function (reduction, _ref3) {
          var _ref4 = (0, _slicedToArray2.default)(_ref3, 2),
              key = _ref4[0],
              childValue = _ref4[1];

          return (0, _set.default)(key, mapper(childValue, key, value))(reduction);
        }, value);
      });
    };
  }
});

exports.default = _default;